import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { client } from '../client';
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';
import { feedQuery, searchQuery } from '../utils/data';

const Feed = () => {
  const [loading, setLoading] = useState(false);
  const [pins, setPins] = useState(null);
  const { categoryId } = useParams();

  useEffect(() => {
    setLoading(true);

    let query;
    if (categoryId) {
      // Search query with approved filter
      query = `${searchQuery(categoryId).replace(
        ']',
        ' && approved == true ]'
      )}`;
    } else {
      // Feed query with approved filter
      query = `${feedQuery.replace(
        ']',
        ' && approved == true ]'
      )}`;
    }

    client.fetch(query).then((data) => {
      console.log('Fetched approved pins:', data);
      setPins(data);
      setLoading(false);
    });
  }, [categoryId]);

  if (loading) return <Spinner message="We are adding new ideas to your feed!" />;

  return (
    <div>
      {pins && pins.length > 0 ? (
        <MasonryLayout pins={pins} />
      ) : (
        <p>No Approved Posts Available.</p>
      )}
    </div>
  );
};

export default Feed;